import Vue from 'vue'
import router from './router';
import App from './App.vue'
import Buefy from 'buefy'
import VueCarousel from 'vue-carousel';
import VueAnalytics from 'vue-analytics';
import axios from 'axios';

import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/css/fontawesome.css";

// Require the main Sass manifest file
require('@/assets/scss/main.scss')

Vue.config.productionTip = false
window.onbeforeunload = function (e) {
  localStorage.clear();
};
// Buefy
Vue.use(Buefy, {
  defaultIconPack: 'far'
})

// Vue Carousel
Vue.use(VueCarousel);

// Axios Default
axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers.common['X-REVSHOPP-TOKEN'] = process.env.VUE_APP_REVSHOPP_TOKEN

// Vue Analytics
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  debug: {
    sendHitTask: process.env.NODE_ENV == 'production'
  },
  linkers: ['www.revshopp.com', 'demo.revshopp.com']
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
